import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AiChatMessage } from '../../components/ai-chat/ai-chat-helpers';

export interface AiChatState {
    messages: AiChatMessage[];
    loading: boolean;
    error: string | null;
    nextId: number;
}

const initialState: AiChatState = { messages: [], loading: false, error: null, nextId: 1 };

export const aiChatSlice = createSlice({
    name: 'aiChat',
    initialState,
    reducers: {
        userMessage(state, action: PayloadAction<string>) {
            state.messages.push({ id: state.nextId++, role: 'user', text: action.payload });
            state.loading = true;
            state.error = null;
        },
        retryStarted(state) {
            state.loading = true;
            state.error = null;
        },
        assistantMessage(state, action: PayloadAction<Omit<AiChatMessage, 'id' | 'role'>>) {
            state.messages.push({ ...action.payload, id: state.nextId++, role: 'assistant' });
            state.loading = false;
        },
        failed(state, action: PayloadAction<string>) {
            state.loading = false;
            state.error = action.payload;
        },
        markReverted(state, action: PayloadAction<number>) {
            const message = state.messages.find((m) => m.id === action.payload);
            if (message) {
                message.reverted = true;
            }
        },
        clear: () => initialState
    }
});

export const aiChatActions = aiChatSlice.actions;
